import axios from "axios";
const BASE_URL = "https://gg-api.nationtonation.ca/api";

// Interface for Payment Data when creating a payment
export interface PaymentData {
  orderId: number;
  amount: number;
  method: string;
  status: string;
}

// Interface for Payment Data when updating a payment
export interface UpdatePaymentData {
  amount: number;
  method: string;
  status: string;
}

// Record a Payment
export const recordPayment = async (paymentData: PaymentData): Promise<any> => {
  try {
    const response = await axios.post(`${BASE_URL}/payments`, paymentData, {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    });
    return response.data;
  } catch (error: any) {
    console.error("Error recording payment:", error.response?.data || error.message);
    throw new Error(error.response?.data?.error || "Failed to record payment.");
  }
};

// Update a Payment
export const updatePayment = async (paymentId: number, paymentData: UpdatePaymentData): Promise<any> => {
  try {
    const response = await axios.put(`${BASE_URL}/payments/${paymentId}`, paymentData, {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    });
    return response.data;
  } catch (error: any) {
    console.error("Error updating payment:", error.response?.data || error.message);
    throw new Error(error.response?.data?.error || "Failed to update payment.");
  }
};

// Delete a Payment
export const deletePayment = async (paymentId: number): Promise<any> => {
  try {
    const response = await axios.delete(`${BASE_URL}/payments/${paymentId}`, {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    });
    return response.data;
  } catch (error: any) {
    console.error("Error deleting payment:", error.response?.data || error.message);
    throw new Error(error.response?.data?.error || "Failed to delete payment.");
  }
};
